"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganisationDetailsLayout = exports.OrganisationDetailsLayoutDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
var use_entities_1 = require("../../hooks/use-entities");
var main_aside_1 = require("../elements/main-aside");
var video_player_1 = require("../elements/video-player");
var content_node_1 = require("./content-node");
var entity_link_value_1 = require("./entity-link-value");
var entity_link_1 = require("./entity-link");
var entity_value_1 = require("./entity-value");
var content_title_1 = require("../elements/content-title");
var entity_multi_value_list_1 = require("./entity-multi-value-list");
var content_section_1 = require("../elements/content-section");
var lodash_1 = require("lodash");
var link_1 = require("../elements/link");
var entity_contact_info_1 = require("./entity-contact-info");
var entity_list_section_1 = require("./entity-list-section");
var grid_1 = require("../elements/grid");
var entity_list_1 = require("./entity-list");
var entity_reverse_controls_1 = require("../../v2/entities/entity-reverse-controls");
exports.OrganisationDetailsLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainAsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var SectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PrimaryContactStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LocationStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TypeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var FeaturedVideoStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(0)),
  tablet: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(0))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    padding: ", " ", " ", ";\n    ", ";\n  "], ["\n    padding: ", " ", " ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(3), theme_1.theme.UNIT(5), theme_1.theme.H_DOT_BG_END())
});
var EntityLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    margin-bottom: ", ";\n    font-weight: 500;\n  "], ["\n    margin-bottom: ", ";\n    font-weight: 500;\n  "])), theme_1.theme.UNIT(3))
});
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var ContactStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContactPrimaryStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var GridStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var ListSectionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ReverseControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Section: (0, styled_components_1.default)(content_section_1.ContentSection)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), SectionStyles),
  Title: (0, styled_components_1.default)(content_title_1.ContentTitle)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  MainAside: (0, styled_components_1.default)(main_aside_1.MainAside)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), MainAsideStyles),
  Main: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), MainStyles),
  Aside: styled_components_1.default.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  ReverseControls: (0, styled_components_1.default)(entity_reverse_controls_1.EntityReverseControls)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), ReverseControlsStyles),
  EntityLink: (0, styled_components_1.default)(entity_link_1.EntityLink)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), EntityLinkStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Grid: (0, styled_components_1.default)(grid_1.Grid)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Description: (0, styled_components_1.default)(content_node_1.ContentNode)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Contact: (0, styled_components_1.default)(entity_contact_info_1.EntityContactInfo)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), ContactStyles),
  ContactPrimary: (0, styled_components_1.default)(entity_contact_info_1.EntityContactInfo)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ContactPrimaryStyles),
  PrimaryContact: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), PrimaryContactStyles),
  Location: (0, styled_components_1.default)(entity_link_value_1.EntityLinkValue)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), LocationStyles),
  Type: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), TypeStyles),
  Industries: (0, styled_components_1.default)(entity_multi_value_list_1.EntityMultiValueList)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), ListStyles),
  FeaturedVideo: (0, styled_components_1.default)(video_player_1.VideoPlayer)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), FeaturedVideoStyles),
  ListSection: (0, styled_components_1.default)(entity_list_section_1.EntityListSection)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), ListSectionStyles),
  List: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), ListStyles)
};
var OrganisationDetailsLayout = function (props) {
  var entity = props.entity,
    className = props.className,
    expertise = props.expertise,
    mainHeader = props.mainHeader,
    mainFooter = props.mainFooter,
    asideHeader = props.asideHeader,
    asideFooter = props.asideFooter,
    banner = props.banner;
  var t = (0, use_lang_1.useLang)();
  var entities = (0, use_entities_1.useEntities)();
  var _a = entity.challenges,
    challenges = _a === void 0 ? [] : _a,
    primaryContact = entity.primaryContact,
    location = entity.location,
    type = entity.type,
    industries = entity.industries,
    featureVideoUrl = entity.featureVideoUrl,
    teamRoles = entity.teamRoles,
    chapterRoles = entity.chapterRoles,
    twitter = entity.twitter,
    url = entity.url,
    linkedin = entity.linkedin,
    facebook = entity.facebook,
    youtube = entity.youtube,
    pinterest = entity.pinterest,
    instagram = entity.instagram,
    _b = entity.posts,
    posts = _b === void 0 ? [] : _b;
  var hasIndustries = entities.Industry && industries && !!industries.length;
  var positions = (0, lodash_1.filter)(entity.positions || [], function (position) {
    return !!position.person;
  });
  var hasPositions = positions && !!positions.length;
  var hasTeamRoles = teamRoles && !!teamRoles.length;
  var hasChapterRoles = chapterRoles && !!chapterRoles.length;
  var hasExpertise = expertise;
  var hasPosts = !!posts.length;
  var hasContact = twitter || url || linkedin || facebook || youtube || pinterest || instagram;
  var hasAside = asideHeader || asideFooter || featureVideoUrl || type || hasContact || primaryContact || hasIndustries || location || !!challenges.length || hasExpertise;
  return React.createElement(My.Container, {
    className: className
  }, banner, React.createElement(My.MainAside, {
    main: React.createElement(My.Main, null, mainHeader, React.createElement(My.Description, {
      title: "About:",
      entity: entity.description
    }), hasTeamRoles && entities.TeamRole && React.createElement(My.Section, {
      title: "{{TEAM_ROLES}}:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: teamRoles.map(function (teamRole) {
        var _a, _b;
        return React.createElement(My.EntityLink, {
          key: teamRole.id,
          entity: teamRole.team
        }, React.createElement(My.Value, {
          badge: (0, lodash_1.get)(teamRole, 'team.type.name'),
          entity: teamRole,
          label: (_a = teamRole.role) === null || _a === void 0 ? void 0 : _a.name,
          name: (_b = teamRole.team) === null || _b === void 0 ? void 0 : _b.name
        }));
      })
    })), hasChapterRoles && entities.ChapterRole && React.createElement(My.Section, {
      title: "{{CHAPTER_ROLES}}:"
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: chapterRoles.map(function (chapterRole) {
        var _a, _b;
        return React.createElement(My.EntityLink, {
          key: chapterRole.id,
          entity: chapterRole.chapter
        }, React.createElement(My.Value, {
          imagePaths: ["chapter.openGraph.image"],
          entity: chapterRole,
          label: (_a = chapterRole.role) === null || _a === void 0 ? void 0 : _a.name,
          name: (_b = chapterRole.chapter) === null || _b === void 0 ? void 0 : _b.name
        }));
      })
    })), hasPositions && React.createElement(My.Section, {
      title: "{{PEOPLE}}:",
      controls: React.createElement(My.ReverseControls, {
        entity: entity,
        reverseEntityTypeNames: ["OrganisationPosition"]
      })
    }, React.createElement(My.Grid, {
      spacing: 0,
      columns: 2,
      items: positions.map(function (position) {
        return React.createElement(My.EntityLink, {
          key: position.id,
          entity: position.person
        }, React.createElement(My.Value, {
          badge: (0, lodash_1.get)(position, 'organisation.type.name'),
          entity: position.person,
          label: position.position,
          name: (0, lodash_1.get)(position, 'person.name')
        }));
      })
    })), hasPosts && React.createElement(My.Section, {
      title: "Posts:"
    }, React.createElement(My.List, {
      showDescription: true,
      items: posts
    })), mainFooter),
    aside: hasAside && React.createElement(My.Aside, null, asideHeader, featureVideoUrl && React.createElement(My.FeaturedVideo, {
      config: {
        youtube: {
          playerVars: {
            modestbranding: 1,
            showinfo: 0
          }
        }
      },
      url: entity.featureVideoUrl
    }), type && React.createElement(My.Section, null, React.createElement(My.Type, {
      entity: type
    })), hasContact && React.createElement(My.Section, {
      title: "Web & Social:"
    }, React.createElement(My.Contact, {
      entity: entity
    })), primaryContact && React.createElement(My.Section, null, React.createElement(My.PrimaryContact, {
      label: "Primary Contact:",
      entity: primaryContact
    }), primaryContact.agreesToSharePersonalInfo && React.createElement(My.ContactPrimary, {
      entity: primaryContact
    })), hasIndustries && React.createElement(My.Section, null, React.createElement(My.Industries, {
      items: industries
    })), location && React.createElement(My.Section, null, React.createElement(My.Location, {
      entity: location
    })), React.createElement(My.ListSection, {
      title: "",
      items: challenges
    }), hasExpertise && React.createElement(My.Section, {
      title: "Expertise:"
    }, expertise), asideFooter)
  }));
};
exports.OrganisationDetailsLayout = OrganisationDetailsLayout;
exports.OrganisationDetailsLayout.defaultProps = exports.OrganisationDetailsLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44;